import moment from 'moment';
import { Colors } from '../../../../../../../../themes/colors';
import { Checkbox } from '../../../../../../../commonComponents/Checkbox';
import CustomPortal from '../../../../../../../commonComponents/CustomPortal';
import { Spinner } from '../../../../../../../commonComponents/Spinner';
import { TabViewContainer } from '../../../../../../../commonComponents/TabViewContainer';
import { LineInfo } from '../../../../LineInfo';
import { useDsoExecutive } from '../../hooks';
import { useAccountInfo } from './hooks/useAccountInfo';
import { useRemoveStaff } from './hooks/useRemoveStaff';
import { useRemoveStaffTermsAndConditions } from './hooks/useRemoveStaffTermsAndConditions';

export const AccountInfo = () => {
  const {
    formPhoneNumber,
    formValues,
    isEditMode,
    isFormValid,
    isLoading,
    staff,
    handleCancelButton,
    handleEditButton,
    handleFormPhoneNumberChanged,
    handleFormValuesChanged,
    handleSubmit,
  } = useAccountInfo();
  const { isDsoExecutive, toggleDsoExecutive } = useDsoExecutive(staff.id);
  const { isShowConfirmModal, onCloseConfirmPopup, onRemoveStaff, onShowConfirmPopup } =
    useRemoveStaff(staff.id);
  const {
    isShowConfirmModalTermsAndConditionsReset,
    onCloseConfirmPopupTermsAndConditionsReset,
    onResetTermsAndConditions,
    onShowConfirmPopupTermsAndConditionsReset,
  } = useRemoveStaffTermsAndConditions(staff.id);

  const hasDSO = !!staff?.dsoID;

  return (
    <>
      <TabViewContainer
        style={{
          margin: 0,
          minWidth: 'auto',
          paddingInline: 24,
        }}
        title="Account Info"
        variant="card"
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <div>
            <LineInfo title="First Name" text={staff.firstName}>
              {isEditMode && (
                <input
                  type="text"
                  className="input-field"
                  style={{ height: 36 }}
                  value={formValues.firstName}
                  onChange={(e) => handleFormValuesChanged('firstName', e.target.value)}
                />
              )}
            </LineInfo>
            <LineInfo title="Last Name" text={staff.lastName}>
              {isEditMode && (
                <input
                  type="text"
                  className="input-field"
                  style={{ height: 36 }}
                  value={formValues.lastName}
                  onChange={(e) => handleFormValuesChanged('lastName', e.target.value)}
                />
              )}
            </LineInfo>
            <LineInfo title="Email" text={staff.email}>
              {isEditMode && (
                <input
                  type="text"
                  className="input-field"
                  style={{ height: 36 }}
                  value={formValues.email}
                  onChange={(e) => handleFormValuesChanged('email', e.target.value)}
                />
              )}
            </LineInfo>
            <LineInfo title="Phone Number" text={staff.phoneNumber || '-'}>
              {isEditMode && (
                <input
                  type="text"
                  className="input-field"
                  style={{ height: 36 }}
                  value={formPhoneNumber}
                  onChange={(e) => handleFormPhoneNumberChanged(e.target.value)}
                />
              )}
            </LineInfo>
            <LineInfo title="T&C Agreed?" text={staff.tnc?.accepted ? 'Yes' : '-'}>
              {isEditMode && (
                <div
                  style={{ display: 'flex', gap: 24, alignItems: 'center', justifyContent: 'end' }}
                >
                  {staff.tnc?.accepted && (
                    <button
                      type="button"
                      className="btn btn-info"
                      style={{ padding: '2px 20px' }}
                      onClick={onShowConfirmPopupTermsAndConditionsReset}
                    >
                      Reset
                    </button>
                  )}

                  <span>{staff.tnc?.accepted ? 'Yes' : '-'}</span>
                </div>
              )}
            </LineInfo>
            <LineInfo
              title="T&C Accepted On"
              text={
                staff.tnc?.acceptedAt
                  ? moment(staff.tnc?.acceptedAt).format('ddd, MMM DD YYYY')
                  : '-'
              }
            />
            {hasDSO && (
              <LineInfo title="DSO Executive">
                <div style={{ flex: 1, display: 'flex', justifyContent: 'end' }}>
                  <Checkbox
                    checked={isDsoExecutive}
                    textStyle={{ color: 'black', flex: '0 0 auto' }}
                    onChanged={toggleDsoExecutive}
                    style={{
                      margin: 0,
                    }}
                    checkboxStyle={{
                      borderRadius: 4,
                      border: `2px solid ${Colors.secondary_500}`,
                      backgroundColor: isDsoExecutive ? Colors.secondary_500 : Colors.white,
                      margin: 0,
                    }}
                  />
                </div>
              </LineInfo>
            )}

            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                gap: 20,
                justifyContent: 'center',
                marginTop: 24,
              }}
            >
              {isEditMode ? (
                <>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    style={{
                      width: '100px',
                    }}
                    onClick={handleCancelButton}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-success"
                    style={{
                      width: '100px',
                    }}
                    onClick={handleSubmit}
                    disabled={!isFormValid}
                  >
                    Save
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-info"
                    style={{ width: '100px' }}
                    onClick={handleEditButton}
                  >
                    Edit
                  </button>
                  <button type="button" className="btn btn-danger" onClick={onShowConfirmPopup}>
                    Delete Account
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </TabViewContainer>
      {isShowConfirmModal && (
        <CustomPortal
          title="Remove Staff Member"
          cancelPressed={onCloseConfirmPopup}
          cancelText="Go Back"
          submitPressed={onRemoveStaff}
          submitText="Remove Staff"
          text="By removing the staff member, the account will be permanently deleted. Are you sure you want to remove this staff ?"
          textStyle={{
            textAlign: 'center',
          }}
        />
      )}

      {isShowConfirmModalTermsAndConditionsReset && (
        <CustomPortal
          title="Reset T&C for Office Staff Member"
          cancelPressed={onCloseConfirmPopupTermsAndConditionsReset}
          cancelText="Cancel"
          submitPressed={onResetTermsAndConditions}
          submitText="Reset"
          text={
            <span>
              Are you sure you would like to reset the T&C for this
              <br />
              office staff member?
            </span>
          }
          textStyle={{
            textAlign: 'center',
          }}
        />
      )}
    </>
  );
};
